import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch, parseJsonSafe } from '../utils/api';

const statusOptions = [
  { value: '', label: 'Todos' },
  { value: 'nuevo', label: 'Nuevo' },
  { value: 'analizado', label: 'Legacy: Diagnóstico' },
  { value: 'propuesta_generada', label: 'Legacy: Propuesta' },
  { value: 'contactado', label: 'Contactado' },
  { value: 'no_interesa', label: 'No interesa' },
  { value: 'ganado', label: 'Ganado' },
  { value: 'perdido', label: 'Perdido' }
];

const CaptacionBusinessPage = () => {
  const token = localStorage.getItem('token');
  const MAX_PLACES_RESULTS = 100;
  const [searchForm, setSearchForm] = useState({ sector: '', city: '', country: 'ES', language: 'auto', maxResults: 20 });

  // Países disponibles para el selector. Code = ISO 3166-1 alpha-2.
  const COUNTRY_OPTIONS = [
    { group: 'Europa', items: [
      { code: 'ES', name: 'España' },
      { code: 'PT', name: 'Portugal' },
      { code: 'FR', name: 'Francia' },
      { code: 'IT', name: 'Italia' },
      { code: 'DE', name: 'Alemania' },
      { code: 'GB', name: 'Reino Unido' },
      { code: 'IE', name: 'Irlanda' },
      { code: 'NL', name: 'Países Bajos' },
      { code: 'BE', name: 'Bélgica' },
      { code: 'CH', name: 'Suiza' },
      { code: 'AT', name: 'Austria' },
      { code: 'LU', name: 'Luxemburgo' },
      { code: 'SE', name: 'Suecia' },
      { code: 'NO', name: 'Noruega' },
      { code: 'DK', name: 'Dinamarca' },
      { code: 'FI', name: 'Finlandia' },
      { code: 'PL', name: 'Polonia' },
      { code: 'GR', name: 'Grecia' },
      { code: 'TR', name: 'Turquía' }
    ] },
    { group: 'América', items: [
      { code: 'US', name: 'Estados Unidos' },
      { code: 'CA', name: 'Canadá' },
      { code: 'MX', name: 'México' },
      { code: 'BR', name: 'Brasil' },
      { code: 'AR', name: 'Argentina' },
      { code: 'CL', name: 'Chile' },
      { code: 'CO', name: 'Colombia' },
      { code: 'PE', name: 'Perú' },
      { code: 'UY', name: 'Uruguay' },
      { code: 'VE', name: 'Venezuela' },
      { code: 'EC', name: 'Ecuador' },
      { code: 'BO', name: 'Bolivia' },
      { code: 'PY', name: 'Paraguay' },
      { code: 'CR', name: 'Costa Rica' },
      { code: 'CU', name: 'Cuba' },
      { code: 'DO', name: 'Rep. Dominicana' },
      { code: 'GT', name: 'Guatemala' },
      { code: 'HN', name: 'Honduras' },
      { code: 'NI', name: 'Nicaragua' },
      { code: 'PA', name: 'Panamá' },
      { code: 'PR', name: 'Puerto Rico' },
      { code: 'SV', name: 'El Salvador' }
    ] },
    { group: 'Asia / Oceanía', items: [
      { code: 'AU', name: 'Australia' },
      { code: 'NZ', name: 'Nueva Zelanda' },
      { code: 'JP', name: 'Japón' },
      { code: 'CN', name: 'China' },
      { code: 'TW', name: 'Taiwán' },
      { code: 'KR', name: 'Corea del Sur' },
      { code: 'IN', name: 'India' }
    ] },
    { group: 'Otros', items: [
      { code: 'RU', name: 'Rusia' },
      { code: 'MA', name: 'Marruecos' },
      { code: 'EG', name: 'Egipto' },
      { code: 'ZA', name: 'Sudáfrica' },
      { code: 'AE', name: 'Emiratos Árabes Unidos' }
    ] }
  ];
  const [searchResults, setSearchResults] = useState([]);
  const [searchPage, setSearchPage] = useState(1);
  const [searchPageSize, setSearchPageSize] = useState(10);
  const [searchFilters, setSearchFilters] = useState({ withEmail: false, withWeb: false });
  const [selectedImports, setSelectedImports] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({ sector: '', city: '', status: '', text: '', withEmail: false });
  const [sectorOptions, setSectorOptions] = useState([]);
  const [selectedTargets, setSelectedTargets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchingEmailId, setFetchingEmailId] = useState(null);
  const [creatingLeadId, setCreatingLeadId] = useState(null);
  const [bulkAction, setBulkAction] = useState(null); // 'email' | null
  const [error, setError] = useState('');
  const [sort, setSort] = useState({ key: 'name', dir: 'asc' });
  const [config, setConfig] = useState({
    cron_enabled: false,
    cron_interval_minutes: 30,
    max_leads_per_cycle: 50
  });
  const [queries, setQueries] = useState([]);
  const [queryForm, setQueryForm] = useState({ keyword: '', city: '', country: '', limit_per_cycle: 20, max_total_results: 0 });
  const [savingConfig, setSavingConfig] = useState(false);
  const [configModal, setConfigModal] = useState(false);

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  const doSearch = async () => {
    if (!searchForm.sector && !searchForm.city) {
      setError('Indica sector o ciudad para buscar');
      return;
    }
    const maxResults = Math.min(Math.max(Number(searchForm.maxResults) || 1, 1), MAX_PLACES_RESULTS);
    setLoading(true);
    setError('');
    setHasSearched(true);
    try {
      const res = await apiFetch('/api/cb/search-places', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ ...searchForm, maxResults })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error buscando negocios');
      const results = data.results || [];
      setSearchResults(results);
      setSelectedImports([]);
      setSearchPage(1);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const importSelected = async () => {
    const selectedNew = selectedImports.filter((idx) => !searchResults[idx]?.exists);
    if (!selectedNew.length) return alert('Selecciona al menos un negocio nuevo');
    try {
      const payload = searchResults.filter((_, idx) => selectedNew.includes(idx));
      const res = await apiFetch('/api/cb/import-businesses', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ businesses: payload })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error importando');
      alert(`Importados ${data.imported || 0}, saltados ${data.skipped || 0}`);
      setSearchResults((prev) => prev.filter((_, idx) => !selectedNew.includes(idx)));
      setSelectedImports([]);
      setSearchPage(1);
      fetchList();
      fetchSectors();
    } catch (err) {
      setError(err.message);
    }
  };

  const fetchConfig = async () => {
    try {
      const res = await apiFetch('/api/cb/config', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && data?.settings) {
        setConfig({
          cron_enabled: !!data.settings.cron_enabled,
          cron_interval_minutes: data.settings.cron_interval_minutes ?? 30,
          max_leads_per_cycle: data.settings.max_leads_per_cycle ?? 50
        });
      }
      if (Array.isArray(data?.queries)) setQueries(data.queries);
    } catch (err) {
      console.error('Error cargando config CB', err);
    }
  };

  const saveConfig = async () => {
    setSavingConfig(true);
    try {
      const toPayloadInt = (value) => {
        if (value === '' || value === null || value === undefined) return null;
        const num = Number(value);
        return Number.isFinite(num) ? num : null;
      };
      const payload = {
        ...config,
        cron_interval_minutes: toPayloadInt(config.cron_interval_minutes),
        max_leads_per_cycle: toPayloadInt(config.max_leads_per_cycle)
      };
      const res = await apiFetch('/api/cb/config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ settings: payload })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar');
      alert('Configuración guardada');
    } catch (err) {
      alert(err.message);
    } finally {
      setSavingConfig(false);
    }
  };

  const createQuery = async () => {
    if (!queryForm.keyword) return alert('Keyword requerida');
    try {
      const res = await apiFetch('/api/cb/queries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(queryForm)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo crear');
      setQueries((prev) => [...prev, data]);
      setQueryForm({ keyword: '', city: '', country: '', limit_per_cycle: 20, max_total_results: 0 });
    } catch (err) {
      alert(err.message);
    }
  };

  const resetQuery = async (id) => {
    try {
      const res = await apiFetch(`/api/cb/queries/${id}/reset`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      if (res.status === 401) return handleUnauthorized();
      const data = await parseJsonSafe(res);
      setQueries((prev) => prev.map((q) => (q.id === id ? data : q)));
    } catch (err) {
      alert(err.message);
    }
  };

  const updateQueryStatus = async (id, status) => {
    try {
      const res = await apiFetch(`/api/cb/queries/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ status })
      });
      if (res.status === 401) return handleUnauthorized();
      const data = await parseJsonSafe(res);
      setQueries((prev) => prev.map((q) => (q.id === id ? data : q)));
    } catch (err) {
      alert(err.message);
    }
  };

  const deleteQuery = async (id) => {
    if (!window.confirm('Eliminar esta automatización?')) return;
    try {
      const res = await apiFetch(`/api/cb/queries/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      if (res.status === 401) return handleUnauthorized();
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'No se pudo eliminar');
      setQueries((prev) => prev.filter((q) => q.id !== id));
    } catch (err) {
      alert(err.message);
    }
  };

  const runNow = async () => {
    try {
      const res = await apiFetch('/api/cb/run-now', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo ejecutar');
      alert(`Ejecutado. Importados: ${data.imported || 0}`);
      fetchList();
      fetchConfig();
      fetchSectors();
    } catch (err) {
      alert(err.message);
    }
  };

  const buildTargetParams = ({ includePagination = true } = {}) => {
    const params = new URLSearchParams();
    if (includePagination) {
      params.append('page', page);
      params.append('pageSize', pageSize);
    }
    if (filters.sector) params.append('sector', filters.sector);
    if (filters.city) params.append('city', filters.city);
    if (filters.status) params.append('status', filters.status);
    if (filters.text) params.append('search', filters.text);
    if (filters.withEmail) params.append('hasEmail', 'true');
    return params;
  };

  const fetchList = async () => {
    setLoading(true);
    setError('');
    try {
      const params = buildTargetParams();
      const res = await apiFetch(`/api/cb/business-targets?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error cargando negocios');
      setList(data.items || []);
      setTotal(Number(data.total || 0));
      setSelectedTargets([]);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, filters]);

  const fetchSectors = async () => {
    try {
      const res = await apiFetch('/api/cb/business-targets/sectors', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && Array.isArray(data)) setSectorOptions(data);
    } catch (err) {
      console.error('Error cargando sectores', err);
    }
  };

  useEffect(() => {
    fetchConfig();
    fetchSectors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalPages = useMemo(() => Math.max(Math.ceil(total / pageSize), 1), [total, pageSize]);
  const sortedTargets = useMemo(() => {
    const copy = [...list];
    copy.sort((a, b) => {
      const valA = (a[sort.key] || '').toString().toLowerCase();
      const valB = (b[sort.key] || '').toString().toLowerCase();
      if (valA < valB) return sort.dir === 'asc' ? -1 : 1;
      if (valA > valB) return sort.dir === 'asc' ? 1 : -1;
      return 0;
    });
    return copy;
  }, [list, sort]);
  const toggleSort = (key) => {
    setSort((prev) => (prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' }));
  };
  const filteredSearchResults = useMemo(() => {
    return searchResults
      .map((r, idx) => ({ ...r, _idx: idx }))
      .filter((r) => {
        if (searchFilters.withEmail && !r.email) return false;
        if (searchFilters.withWeb && !r.website) return false;
        return true;
      });
  }, [searchResults, searchFilters]);
  const searchTotalPages = Math.max(Math.ceil(filteredSearchResults.length / searchPageSize), 1);
  const paginatedSearchResults = useMemo(() => {
    const start = (searchPage - 1) * searchPageSize;
    return filteredSearchResults.slice(start, start + searchPageSize);
  }, [filteredSearchResults, searchPage, searchPageSize]);
  const selectableSearchResults = useMemo(
    () => paginatedSearchResults.filter((r) => !r.exists),
    [paginatedSearchResults]
  );
  const selectedImportSet = useMemo(() => new Set(selectedImports), [selectedImports]);
  const allImportsSelected = useMemo(
    () =>
      selectableSearchResults.length > 0 &&
      selectableSearchResults.every((r) => selectedImportSet.has(r._idx)),
    [selectableSearchResults, selectedImportSet]
  );

  const fetchEmail = async (id, { silent = false, skipRefresh = false } = {}) => {
    if (fetchingEmailId && !silent) return { ok: false };
    if (!silent) setFetchingEmailId(id);
    try {
      const res = await apiFetch(`/api/cb/business-targets/${id}/fetch-email`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error obteniendo email');
      if (!skipRefresh) await fetchList();
      if (!silent) {
        alert(data.email ? `Email encontrado: ${data.email}` : 'No se encontró email');
      }
      return { ok: true, email: data.email };
    } catch (err) {
      if (!silent) setError(err.message);
      return { ok: false, error: err.message };
    } finally {
      if (!silent) setFetchingEmailId(null);
    }
  };

  const createLeadFromTarget = async (id) => {
    if (creatingLeadId) return;
    setCreatingLeadId(id);
    try {
      const res = await apiFetch(`/api/cb/business-targets/${id}/create-lead`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo crear el lead');
      await fetchList();
      if (data.status === 'existing') {
        alert('Este lead ya existía en Clientes. Se ha vinculado al target.');
      } else {
        alert('Lead creado en Clientes y enviado al embudo.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setCreatingLeadId(null);
    }
  };

  const toggleSelectTarget = (id, checked) => {
    setSelectedTargets((prev) => checked ? [...prev, id] : prev.filter((x) => x !== id));
  };

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedTargets(list.map((b) => b.id));
    } else {
      setSelectedTargets([]);
    }
  };

  const deleteSelected = async () => {
    if (!selectedTargets.length) return;
    if (!window.confirm(`Eliminar ${selectedTargets.length} negocio(s)?`)) return;
    try {
      const res = await apiFetch('/api/cb/business-targets', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ ids: selectedTargets })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudieron eliminar');
      fetchList();
    } catch (err) {
      setError(err.message);
    }
  };

  const fetchEmailSelected = async () => {
    if (!selectedTargets.length) return;
    setBulkAction('email');
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    let found = 0;
    let fail = 0;
    const retryIds = [];
    try {
      for (const id of selectedTargets) {
        const result = await fetchEmail(id, { silent: true, skipRefresh: true });
        if (result?.ok && result.email) {
          found += 1;
        } else {
          retryIds.push(id);
        }
        // Pequeña pausa para evitar bloqueos puntuales por ráfagas
        if (selectedTargets.length > 3) {
          // eslint-disable-next-line no-await-in-loop
          await sleep(120);
        }
      }

      // Segunda pasada automática para capturar emails intermitentes.
      for (const id of retryIds) {
        const result = await fetchEmail(id, { silent: true, skipRefresh: true });
        if (result?.ok && result.email) found += 1;
        else if (!result?.ok) fail += 1;
        if (retryIds.length > 3) {
          // eslint-disable-next-line no-await-in-loop
          await sleep(120);
        }
      }
      await fetchList();
      const noEmail = Math.max(selectedTargets.length - found - fail, 0);
      alert(`Emails encontrados: ${found}. Sin email: ${noEmail}. Errores: ${fail}.`);
    } finally {
      setBulkAction(null);
    }
  };

  return (
    <div className="small">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Captación Business</h2>
        <div className="d-flex align-items-center gap-2">
          <button className="btn btn-outline-secondary btn-sm" onClick={() => setConfigModal(true)}>Configuración / Automatización</button>
          {loading && <span className="badge bg-info text-dark">Cargando...</span>}
        </div>
      </div>
      <div className="alert alert-light border small">
        <div className="fw-bold mb-1">Cómo leer esta pantalla</div>
        <ul className="mb-0 ps-3">
          <li><strong>Búsqueda</strong>: encuentra negocios e impórtalos como leads.</li>
          <li><strong>Leads</strong>: listado de negocios captados con filtros por sector, ciudad y estado.</li>
          <li><strong>Email</strong>: puedes obtener emails de forma individual o en lote.</li>
        </ul>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="card shadow-sm mb-3">
        <div className="card-body">
          <h5>Búsqueda en Google Places</h5>
          <div className="text-muted small mb-2">Busca nuevos negocios para importar como targets.</div>
          <div className="row g-2">
            <div className="col-md-3">
              <label className="form-label">Sector</label>
              <input className="form-control" value={searchForm.sector} onChange={(e) => setSearchForm((p) => ({ ...p, sector: e.target.value }))} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Ciudad</label>
              <input className="form-control" value={searchForm.city} onChange={(e) => setSearchForm((p) => ({ ...p, city: e.target.value }))} />
            </div>
            <div className="col-md-2">
              <label className="form-label">País</label>
              <select
                className="form-select"
                value={searchForm.country}
                onChange={(e) => setSearchForm((p) => ({ ...p, country: e.target.value }))}
              >
                <option value="">— Cualquiera —</option>
                {COUNTRY_OPTIONS.map((g) => (
                  <optgroup key={g.group} label={g.group}>
                    {g.items.map((c) => (
                      <option key={c.code} value={c.code}>{c.name} ({c.code})</option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Idioma</label>
              <select
                className="form-select"
                value={searchForm.language}
                onChange={(e) => setSearchForm((p) => ({ ...p, language: e.target.value }))}
                title="Idioma de la búsqueda en Google. Auto lo deduce del país."
              >
                <option value="auto">Auto (según país)</option>
                <option value="es">Español</option>
                <option value="en">Inglés</option>
                <option value="fr">Francés</option>
                <option value="de">Alemán</option>
                <option value="it">Italiano</option>
                <option value="pt">Portugués</option>
                <option value="nl">Neerlandés</option>
              </select>
            </div>
            <div className="col-md-1">
              <label className="form-label">Máx. ({MAX_PLACES_RESULTS})</label>
              <input
                className="form-control"
                type="number"
                min="1"
                max={MAX_PLACES_RESULTS}
                value={searchForm.maxResults}
                onChange={(e) => setSearchForm((p) => ({ ...p, maxResults: Number(e.target.value) }))}
              />
            </div>
            <div className="col-md-1 d-flex align-items-end">
              <button className="btn btn-primary w-100" onClick={doSearch}>Buscar</button>
            </div>
          </div>
          {searchResults.length > 0 && (
            <div className="mt-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-3">
                  <span>{filteredSearchResults.length} resultados</span>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="srEmail" checked={searchFilters.withEmail} onChange={(e) => { setSearchPage(1); setSearchFilters((p) => ({ ...p, withEmail: e.target.checked })); }} />
                    <label className="form-check-label" htmlFor="srEmail">Solo con email</label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="srWeb" checked={searchFilters.withWeb} onChange={(e) => { setSearchPage(1); setSearchFilters((p) => ({ ...p, withWeb: e.target.checked })); }} />
                    <label className="form-check-label" htmlFor="srWeb">Solo con web</label>
                  </div>
                </div>
                <button className="btn btn-sm btn-success" onClick={importSelected}>Importar seleccionados</button>
              </div>
              <div className="table-responsive">
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          checked={allImportsSelected}
                          onChange={(e) => {
                            setSelectedImports(e.target.checked ? selectableSearchResults.map((r) => r._idx) : []);
                          }}
                        />
                      </th>
                      <th>Nombre</th>
                      <th>Website</th>
                      <th>Ciudad</th>
                      <th>Sector</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedSearchResults.map((r) => (
                      <tr key={`${r.placeId || r.name}-${r._idx}`}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedImportSet.has(r._idx)}
                            disabled={r.exists}
                            onChange={(e) => {
                              setSelectedImports((prev) =>
                                e.target.checked ? [...prev, r._idx] : prev.filter((x) => x !== r._idx)
                              );
                            }}
                          />
                        </td>
                        <td>
                          {r.name}
                          {r.exists && <span className="badge bg-secondary ms-2">Ya existe</span>}
                        </td>
                        <td>
                          {r.website ? (
                            <span title={r.website}>{r.website.length > 25 ? `${r.website.slice(0, 25)}…` : r.website}</span>
                          ) : '-'}
                        </td>
                        <td>{r.city || '-'}</td>
                        <td>{r.sector || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div>Página {searchPage} de {searchTotalPages} (total {filteredSearchResults.length})</div>
                <div className="d-flex gap-2 align-items-center">
                  <select className="form-select form-select-sm" style={{ width: 90 }} value={searchPageSize} onChange={(e) => { setSearchPage(1); setSearchPageSize(Number(e.target.value)); }}>
                    {[5, 10, 20, 50].map((n) => <option key={n} value={n}>{n} / pág</option>)}
                  </select>
                  <button className="btn btn-outline-secondary btn-sm" disabled={searchPage <= 1} onClick={() => setSearchPage((p) => p - 1)}>Anterior</button>
                  <button className="btn btn-outline-secondary btn-sm" disabled={searchPage >= searchTotalPages} onClick={() => setSearchPage((p) => p + 1)}>Siguiente</button>
                </div>
              </div>
            </div>
          )}
          {hasSearched && !loading && searchResults.length === 0 && !error && (
            <div className="alert alert-info mt-3">No se encontraron negocios con esos criterios.</div>
          )}
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Targets</h5>
            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={async () => {
                  try {
                    const params = buildTargetParams({ includePagination: false });
                    const res = await apiFetch(`/api/cb/business-targets/export?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
                    if (res.status === 401) return handleUnauthorized();
                    if (!res.ok) {
                      const data = await parseJsonSafe(res);
                      throw new Error((data && data.message) || 'Error exportando');
                    }
                    const blob = await res.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'business_targets.csv';
                    a.click();
                    window.URL.revokeObjectURL(url);
                  } catch (err) {
                    setError(err.message);
                  }
                }}
              >
                Exportar CSV
              </button>
              <button className="btn btn-outline-success btn-sm" disabled={!selectedTargets.length || bulkAction === 'email'} onClick={fetchEmailSelected}>
                {bulkAction === 'email' ? 'Obteniendo emails...' : 'Obtener email'}
              </button>
              <button className="btn btn-outline-danger btn-sm" disabled={!selectedTargets.length} onClick={deleteSelected}>Eliminar seleccionados</button>
              <span className="text-muted small d-none d-md-inline">Seleccionados: {selectedTargets.length}</span>
            </div>
          </div>
          <div className="text-muted small mb-2">Listado completo de leads captados. Usa filtros y acciones para obtener emails.</div>
          <div className="row g-2 mb-3">
            <div className="col-md-3 col-sm-6">
              <input className="form-control form-control-sm" placeholder="Buscar" value={filters.text} onChange={(e) => { setPage(1); setFilters((p) => ({ ...p, text: e.target.value })); }} />
            </div>
            <div className="col-md-2 col-sm-6">
              <select className="form-select form-select-sm" value={filters.sector} onChange={(e) => { setPage(1); setFilters((p) => ({ ...p, sector: e.target.value })); }}>
                <option value="">Sector (todos)</option>
                {sectorOptions.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div className="col-md-2 col-sm-6">
              <input className="form-control form-control-sm" placeholder="Ciudad" value={filters.city} onChange={(e) => { setPage(1); setFilters((p) => ({ ...p, city: e.target.value })); }} />
            </div>
            <div className="col-md-2 col-sm-6">
              <select className="form-select form-select-sm" value={filters.status} onChange={(e) => { setPage(1); setFilters((p) => ({ ...p, status: e.target.value })); }}>
                {statusOptions.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
            <div className="col-md-3 col-sm-6 d-flex align-items-center">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="filterEmail" checked={filters.withEmail} onChange={(e) => { setPage(1); setFilters((p) => ({ ...p, withEmail: e.target.checked })); }} />
                <label className="form-check-label ms-1" htmlFor="filterEmail">Solo con email</label>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th style={{ width: 30 }}>
                    <input
                      type="checkbox"
                      checked={selectedTargets.length === list.length && list.length > 0}
                      onChange={(e) => toggleSelectAll(e.target.checked)}
                    />
                  </th>
                  <th role="button" onClick={() => toggleSort('name')}>Empresa</th>
                  <th>Website</th>
                  <th>Email</th>
                  <th role="button" onClick={() => toggleSort('sector')}>Sector</th>
                  <th role="button" onClick={() => toggleSort('city')}>Ciudad</th>
                  <th style={{ width: 220 }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {sortedTargets.length === 0 && <tr><td colSpan="7">Sin registros.</td></tr>}
                {sortedTargets.map((b) => (
                  <tr key={b.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedTargets.includes(b.id)}
                        onChange={(e) => toggleSelectTarget(b.id, e.target.checked)}
                      />
                    </td>
                    <td>{b.name}{b.client_id && <span className="badge bg-success ms-2" title="Este negocio está vinculado a un cliente existente: queda fuera de las campañas frías">Ya es cliente</span>}</td>
                    <td>
                      {b.website ? (
                        <span title={b.website}>{b.website.length > 25 ? `${b.website.slice(0, 25)}…` : b.website}</span>
                      ) : '-'}
                    </td>
                    <td>{b.email || '-'}</td>
                    <td>{b.sector || '-'}</td>
                    <td>{b.city || '-'}</td>
                    <td className="text-end">
                      <div className="d-flex flex-column align-items-end gap-1">
                        {b.client_id ? (
                          <Link className="btn btn-sm btn-outline-primary" to={`/clientes/${b.client_id}`}>
                            Ver lead
                          </Link>
                        ) : (
                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={creatingLeadId === b.id}
                            onClick={() => createLeadFromTarget(b.id)}
                          >
                            {creatingLeadId === b.id ? 'Creando...' : 'Crear lead'}
                          </button>
                        )}
                        <button className="btn btn-sm btn-outline-success" disabled={!b.website || fetchingEmailId === b.id || bulkAction} onClick={() => fetchEmail(b.id)}>
                          {fetchingEmailId === b.id ? <span className="spinner-border spinner-border-sm me-1" role="status" /> : null}
                          Obtener email
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <div>Página {page} de {totalPages} (total {total})</div>
            <div className="d-flex gap-2 align-items-center">
              <select className="form-select form-select-sm" style={{ width: 110 }} value={pageSize} onChange={(e) => { setPage(1); setPageSize(Number(e.target.value)); }}>
                {[10, 20, 50].map((n) => <option key={n} value={n}>{n} / pág</option>)}
              </select>
              <button className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Anterior</button>
              <button className="btn btn-outline-secondary btn-sm" disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}>Siguiente</button>
            </div>
          </div>
        </div>
      </div>

      {configModal && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Configuración / Automatización</h5>
                <button className="btn-close" onClick={() => setConfigModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="fw-semibold">Automatización de captación</span>
                  <div className="d-flex gap-2">
                    <button className="btn btn-outline-secondary btn-sm" onClick={runNow}>Ejecutar ahora</button>
                    <button className="btn btn-primary btn-sm" onClick={saveConfig} disabled={savingConfig}>
                      {savingConfig ? 'Guardando...' : 'Guardar config'}
                    </button>
                  </div>
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label small">Cron activo</label>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" checked={config.cron_enabled} onChange={(e) => setConfig((p) => ({ ...p, cron_enabled: e.target.checked }))} />
                      <label className="form-check-label">Programar captación</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small">Intervalo (min)</label>
                    <input className="form-control form-control-sm" type="number" min="1" max="1440" value={config.cron_interval_minutes} onChange={(e) => setConfig((p) => ({ ...p, cron_interval_minutes: Number(e.target.value) }))} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small">Máx. leads/ciclo</label>
                    <input className="form-control form-control-sm" type="number" value={config.max_leads_per_cycle} onChange={(e) => setConfig((p) => ({ ...p, max_leads_per_cycle: Number(e.target.value) }))} />
                  </div>
                </div>
                <hr />
                <div className="row g-2 align-items-end">
                  <div className="col-lg-3 col-md-4">
                    <label className="form-label small">Keyword / Sector</label>
                    <input className="form-control form-control-sm" value={queryForm.keyword} onChange={(e) => setQueryForm((p) => ({ ...p, keyword: e.target.value }))} />
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <label className="form-label small">Ciudad</label>
                    <input className="form-control form-control-sm" value={queryForm.city} onChange={(e) => setQueryForm((p) => ({ ...p, city: e.target.value }))} />
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <label className="form-label small">País</label>
                    <input className="form-control form-control-sm" value={queryForm.country} onChange={(e) => setQueryForm((p) => ({ ...p, country: e.target.value }))} />
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <label className="form-label small">Máx. por ciclo</label>
                    <input className="form-control form-control-sm" type="number" value={queryForm.limit_per_cycle} onChange={(e) => setQueryForm((p) => ({ ...p, limit_per_cycle: Number(e.target.value) }))} />
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <label className="form-label small">Máx. totales</label>
                    <input className="form-control form-control-sm" type="number" value={queryForm.max_total_results} onChange={(e) => setQueryForm((p) => ({ ...p, max_total_results: Number(e.target.value) }))} />
                  </div>
                  <div className="col-lg-1 col-md-3 d-grid">
                    <button className="btn btn-outline-primary btn-sm" onClick={createQuery}>Añadir búsqueda</button>
                  </div>
                </div>
                <div className="table-responsive mt-3">
                  <table className="table table-sm align-middle">
                    <thead>
                      <tr>
                        <th>Keyword</th>
                        <th>Ciudad</th>
                        <th>Estado</th>
                        <th>Progreso</th>
                        <th>Límite ciclo</th>
                        <th>Máx. total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {queries.length === 0 && <tr><td colSpan="7" className="text-muted small">Sin consultas.</td></tr>}
                      {queries.map((q) => {
                        const progreso = q.max_total_results > 0 ? `${q.total_found}/${q.max_total_results}` : `${q.total_found}`;
                        const statusBadge = () => {
                          switch (q.status) {
                            case 'activa': return 'badge bg-success';
                            case 'pausada': return 'badge bg-warning text-dark';
                            case 'completada': return 'badge bg-secondary';
                            default: return 'badge bg-light text-dark';
                          }
                        };
                        const isActiva = q.status === 'activa';
                        const isPausada = q.status === 'pausada';
                        return (
                          <tr key={q.id}>
                            <td>{q.keyword}</td>
                            <td>{q.city || '-'}</td>
                            <td><span className={`${statusBadge()} text-uppercase`}>{q.status}</span></td>
                            <td>{progreso}</td>
                            <td>{q.limit_per_cycle}</td>
                            <td>{q.max_total_results || '∞'}</td>
                            <td className="text-end d-flex gap-1 justify-content-end">
                              {isPausada && <button className="btn btn-sm btn-outline-success" onClick={() => updateQueryStatus(q.id, 'activa')}>Activar</button>}
                              {isActiva && <button className="btn btn-sm btn-outline-warning" onClick={() => updateQueryStatus(q.id, 'pausada')}>Pausar</button>}
                              {isActiva || isPausada ? (
                                <button className="btn btn-sm btn-outline-danger" onClick={() => updateQueryStatus(q.id, 'completada')}>Completar</button>
                              ) : null}
                              <button className="btn btn-sm btn-outline-secondary" onClick={() => resetQuery(q.id)}>Reiniciar</button>
                              <button className="btn btn-sm btn-outline-dark" onClick={() => deleteQuery(q.id)}>Eliminar</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setConfigModal(false)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CaptacionBusinessPage;
